// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"9c172d51","456":"86c5fd0e","656":"dc936764","756":"8cc47cbb","787":"e9580f61","968":"84e8d6c1"}[chunkId] + ".chunk.js";
};